// Un elemento può essere trascinato e rilasciato sul canvas solo se è
// esplicitamente marcato come sorgente di drag (le foto della sidebar foto,
// che portano `data-canvas-drag-source="true"`). Serve a impedire che
// immagini di interfaccia — l'anteprima dentro un dialog SweetAlert2, le
// icone degli strumenti IA, qualsiasi altra `<img>` della pagina — finiscano
// sul canvas per un drag accidentale, dato che il listener `dragend` è
// globale su `body`.
export const isCanvasDragSource = (target) =>
  Boolean(
    target &&
      target.src &&
      target.dataset &&
      target.dataset.canvasDragSource === 'true'
  );
